import "./IconWatchlistGroup.scss";
import { ReactComponent as WatchlistGroupIcon } from "./svg/watchlistGroup.svg";

interface Props {
  className?: string;
}

export const IconWatchlistGroup = ({ className = "" }: Props) => {
  return (
    <span className={`IconWatchlistGroup ${className}`}>
      <WatchlistGroupIcon />
    </span>
  );
};
